(ns ncr.widgets.util
  (:require
   [clojure.string :as str]
   [clojure.core.match :refer [match]]
   [uix.core.alpha :as uix]
   ["react-dom/server" :as react-dom-server]))

(defn ^boolean named? [x]
  (or (keyword? x)
    (symbol? x)))

(defn class-names
  ([])
  ([class]
   (if (coll? class)
     (let [classes (keep (fn [c]
                           (if c
                             (if (named? c)
                               (name c)
                               c)))
                     class)]
       (if (seq classes)
         (str/join " " classes)))
     (if (named? class)
       (name class)
       class)))
  ([a b]
   (if a
     (if b
       (str (class-names a) " " (class-names b))
       (class-names a))
     (class-names b)))
  ([a b & rst]
   (reduce class-names
     (class-names a b)
     rst)))

(defn- merge-class [p1 p2]
  (if (or (contains? p1 :class) (contains? p2 :class))
    (assoc p2 :class (class-names (:class p1) (:class p2)))
    p2))

(defn- merge-style [p1 p2]
  (let [style (when-let [s1 (:style p1)]
                (when-let [s2 (:style p2)]
                  (merge s1 s2)))]
    (if (nil? style)
      p2
      (assoc p2 :style style))))


(defn merge-props*
  ([] nil)
  ;; Normalize :class even if there are no merging
  ([p]
   (if-let [c (:class p)]
     (assoc p :class (class-names c))
     p))
  ([p1 p2]
   (if (nil? p1)
     (if-let [c (:class p2)]
       (assoc p2 :class (class-names c))
       p2)
     (do
       (assert (map? p1)
         (str "Property must be a map, not " (pr-str p1)))
       (merge p1 (merge-style p1 (merge-class p1 p2))))))
  ([p1 p2 & ps]
   (reduce merge-props* (merge-props* p1 p2) ps)))

(defn collect-props [defaults in & args]
  (loop [acc defaults in in]
    (match in
      (f :guard fn?)
      (recur acc (apply f args))

      [(props :guard map?)]
      [(merge-props* acc props)]

      [(props :guard map?) (f :guard fn?)]
      (recur (merge-props* acc props) (apply f args))

      [(props :guard map?) body']
      (recur (merge-props* acc props) body')

      else
      [acc else])))

(defn hiccup-element? [e]
  (and
    (vector? e)
    (let [[first & _] e]
      (or
        (keyword? first)
        (fn? first)))))

(defn render-to-string [e]
  (if (hiccup-element? e)
    (react-dom-server/renderToStaticMarkup
      (uix/as-element e))
    e))